module.exports = __webpack_public_path__ + "static/projekt-opakowania-galaxy-f5e4d96fa8cbbd0187ed76ad92c58147.png";